import React, { useState } from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import { Modal, Button } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faPlus,
  faUndo,
  faAngleUp,
  faArrowDown,
  faSave,
  faTimes,
  faPen,
  faChevronRight,
} from "@fortawesome/free-solid-svg-icons";
import axios from "axios";
import "bootstrap/dist/css/bootstrap.css";
import "react-tabs/style/react-tabs.css";
import apiUrl from "../../apiUrlConstant";
import { Redirect, withRouter, Link } from "react-router-dom";
import { PdfReader } from "../../utils/DocumentViewer";
import SimpleReactValidator from "simple-react-validator";
import { PopupMessage } from "../../utils/utils";
import dateFormat, { masks } from "dateformat";
import { leaseDateFormat } from "../../utils/utils";

const headers = {
  "Content-Type": "application/json",
  Authorization: "Bearer " + localStorage.getItem("TOKEN"),
};

class OtherClauses extends React.Component {
  countError = "";
  state = {
    messsagePopup: false,
    popupContent: "Data Saved Successfully!",
    renewalLeaseTermDD: "",
    renewalLeaseTermMM: "",
    renewalLeaseTermYY: "",
    leaseTermDD: "",
    leaseTermMM: "",
    leaseTermYY: "",
    leaseUploadDocumentDate: "",
    redirect: false,
    isOpen: false,
    pageNo: 1,
    documentUrl: "",
    otherClausesDetails: [],
    otherClauses: [],
    uploadedDocuments: [],
    uploadedDocumentNames: [],
    currentDocument: "",
    popupContentType: "pdf",
    popupContentTypeDescription: "",
    initialValues: {
      otherDetails: {
        clauseName: "",
        details: "",
        document: "",
        pageNo: "",
      },
    },
  };
  openModal = () => this.setState({ isOpen: true });
  closeModal = () => this.setState({ isOpen: false });

  constructor(props) {
    super(props);

    this.mainFormValidator = new SimpleReactValidator({
      autoForceUpdate: this,
      messages: {
        countError: "Validation has failed!", // will override all messages
      },
    });

    this.validator = new SimpleReactValidator({
      autoForceUpdate: this,
    });
  }

  showDocumentDate(docType) {
    let obj = this.state.uploadedDocuments.find(
      (o) => o.leaseDocumentUrl === docType
    );
    if (obj !== undefined) {
      return leaseDateFormat(obj.leaseUploadDocumentDate);
    } else {
      return "";
    }
  }

  formatDate(date) {
    return leaseDateFormat(date);
  }


  addOtherDetails = (values) => {
    if (!this.validator.allValid()) {
      console.log(this.validator);
      this.validator.showMessages();
      return false;
    }

    let docSelected = this.state.uploadedDocuments.find((obj) => obj.leaseDocumentUrl === values.otherDetails.document )
    
    values.otherDetails.document = docSelected.leaseDocumentType; 
    values.otherDetails.documentUrl = docSelected.leaseDocumentUrl; 
    
    var _otherClausesDetails = this.state.otherClausesDetails;
    _otherClausesDetails.push(values.otherDetails);
    this.setState({
      otherClausesDetails: _otherClausesDetails,
    });
    const index = this.state.otherClauses.findIndex(
      (x) => x.clause_name === values.otherDetails.clauseName
    );
    if (index > -1) {
      this.state.otherClauses.splice(index, 1);
    }
    this.setState({});
    console.log(this.state.otherClausesDetails, "needed");

    return true;
  };

  componentDidMount() {
    fetch(`${apiUrl.apiUrl.url}/legal-clause/get-clauses`, {headers})
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        this.setState({
          otherClauses: data,
        });
      })
      .catch((error) => {
        console.log(error);
      });

    let athis = this;
    axios({
      url: `${apiUrl.apiUrl.url}/create-lease/fetch-lease-other-clauses-details?id=${this.props.match.params.id}`,
      method: "GET",
    }).then(function (response) {
      let data = response.data; 
      athis.state.renewalLeaseTermYY = data.renewalLeaseTermYY;
      athis.state.renewalLeaseTermDD = data.renewalLeaseTermDD;
      athis.state.renewalLeaseTermMM = data.renewalLeaseTermMM;

      for (let i = 0; i < data.lease_documents.length; i++) {
        athis.state.uploadedDocumentNames.push(
          data.lease_documents[i].leaseDocumentType
        );
      }
      for (let i = 0; i < data.otherClausesDetails.length; i++) {
        const index = athis.state.otherClauses.findIndex(
          (x) => x.clause_name === data.otherClausesDetails[i].clauseName
        );
        if (index > -1) {
          athis.state.otherClauses.splice(index, 1);
        }
      }
      athis.setState({
        initialValues: data,
        otherClausesDetails: data.otherClausesDetails,
        leaseTermDD: data.leaseTermDD,
        leaseTermMM: data.leaseTermMM,
        leaseTermYY: data.leaseTermYY,
        notes_15: data.notes_15,
        pageNo: data.otherClausesDetails.pageNo,
        leaseUploadDocumentDate: data.leaseUploadDocumentDate,
        uploadedDocuments: data.lease_documents,
      });
      var _intialValues = athis.state.initialValues;
      _intialValues.otherDetails = {
        clauseName: "",
        details: "",
        document: "",
        pageNo: "",
      };
      athis.setState({
        initialValues: _intialValues,
      });
    });  

    // fetch(
    //   `${apiUrl.apiUrl.url}/create-lease/fetch-lease-other-clauses-details?id=${this.props.match.params.id}`
    // )
    //   .then((response) => {
    //     return response.json();
    //   })
    //   .then((data) => {
    //     this.state.renewalLeaseTermYY = data.renewalLeaseTermYY;
    //     this.state.renewalLeaseTermDD = data.renewalLeaseTermDD;
    //     this.state.renewalLeaseTermMM = data.renewalLeaseTermMM;

    //     for (let i = 0; i < data.lease_documents.length; i++) {
    //       this.state.uploadedDocumentNames.push(
    //         data.lease_documents[i].leaseDocumentType
    //       );
    //     }
    //     for (let i = 0; i < data.otherClausesDetails.length; i++) {
    //       const index = this.state.otherClauses.findIndex(
    //         (x) => x.clause_name === data.otherClausesDetails[i].clauseName
    //       );
    //       if (index > -1) {
    //         this.state.otherClauses.splice(index, 1);
    //       }
    //     }
    //     this.setState({
    //       initialValues: data,
    //       otherClausesDetails: data.otherClausesDetails,
    //       leaseTermDD: data.leaseTermDD,
    //       leaseTermMM: data.leaseTermMM,
    //       leaseTermYY: data.leaseTermYY,
    //       notes_15: data.notes_15,
    //       pageNo: data.otherClausesDetails.pageNo,
    //       leaseUploadDocumentDate: data.leaseUploadDocumentDate,
    //       uploadedDocuments: data.lease_documents,
    //     });
    //     var _intialValues = this.state.initialValues;
    //     _intialValues.otherDetails = {
    //       clauseName: "",
    //       details: "",
    //       document: "",
    //       pageNo: "",
    //     };
    //     this.setState({
    //       initialValues: _intialValues,
    //     });
    //   })
    //   .catch((error) => {
    //     console.log(error);
    //   });
  }

  redirectAfterSave = () => {
    this.setState({ redirect: true, messsagePopup: false, });
  };

  render() {
    if (this.state.redirect == true) {
      let url = this.props.match;

      this.state.redirect = false;
      return (
        <Redirect
          push
          to={"/createlease/charge-rent/" + this.props.match.params.id}
        />
      );
    }
    return (
      <div
        className="parentContainer createLease"

      >
        <div>
          <div>
            <div className="absoluteItemForTopBar">
              <div className="new_breadcrumbs_design">
                <ul className="d-flex align-items-center gap-3 p-0 m-0">
                  <li>Create Lease</li>
                  <li><FontAwesomeIcon icon={faChevronRight} /></li>
                  <li>Critical Clause</li>
                  <li><FontAwesomeIcon icon={faChevronRight} /></li>
                  <li>
                    <a href="#">Other Clauses</a>
                  </li>
                </ul>
              </div>
            </div>


            <Formik
              initialValues={this.state.initialValues}
              enableReinitialize
              onSubmit={(values, actions) => {
                if (this.state.otherClausesDetails.length == 0) {
                  this.mainFormValidator.showMessages("countError");
                  return false;
                }
                values.otherClausesDetails = this.state.otherClausesDetails;
                var self = this;
                axios({
                  method: "post",
                  url: `${apiUrl.apiUrl.url}/create-lease/update-lease-other-clauses-details?lease_id=${this.props.match.params.id}`,
                  data: values,
                }).then(function (response) {
                  if (!response.data.success) {
                    actions.setSubmitting(false);
                    actions.setErrors(response.data);
                  } else {
                    self.setState({ messsagePopup: true });
                  }
                });
              }}
            >
              {({
                values,

                errors,

                touched,

                handleChange,

                handleBlur,

                handleSubmit,

                isSubmitting,

                resetForm,
              }) => (
                <>
                  <div className="unitFormContainerNew">
                    <Form autoComplete="off" >
                      <div className="newGridSectionParent">
                        <div className="newGridSectionForFormMain">

                          <div className="newGridSectionInner">
                            <label>
                              Lease Term (YY-MM-DD) <span className="astrik">*</span>
                            </label>
                            <div className="position-relative">
                              <div className="row m-0">
                                <div className="col-sm-4 p-0">
                                  <Field
                                    type="text"
                                    name="leaseTermYY"
                                    placeholder="YY"
                                    className="centerPlaceHolder"
                                    value={this.state.leaseTermYY}
                                  />

                                </div>
                                <div className="col-sm-4">
                                  <Field
                                    type="text"
                                    name="leaseTermMM"
                                    placeholder="MM"
                                    className="centerPlaceHolder"
                                    value={this.state.leaseTermMM}
                                  />

                                </div>
                                <div className="col-sm-4 p-0">
                                  <Field
                                    type="text"
                                    name="leaseTermDD"
                                    placeholder="DD"
                                    className="centerPlaceHolder"
                                    value={this.state.leaseTermDD}
                                  />

                                </div>
                              </div>
                              <ErrorMessage
                                name="leaseTerm"
                                component="div"
                                className="text-red"
                              />
                            </div>
                          </div>

                          <div className="newGridSectionInner">
                            <label>
                              Lease Renewal Term (YY-MM-DD) <span className="astrik">*</span>
                            </label>
                            <div className="position-relative">
                              <div className="row m-0">
                                <div className="col-sm-4 p-0">
                                  <Field
                                    type="text"
                                    name="leaseRenewalTermYY"
                                    placeholder="YY"
                                    className="centerPlaceHolder"
                                    value={this.state.renewalLeaseTermYY}
                                  />

                                </div>
                                <div className="col-sm-4">
                                  <Field
                                    type="text"
                                    name="leaseRenewalTermMM"
                                    placeholder="MM"
                                    className="centerPlaceHolder"
                                    value={this.state.renewalLeaseTermMM}
                                  />

                                </div>
                                <div className="col-sm-4 p-0">
                                  <Field
                                    type="text"
                                    name="leaseRenewalTermDD"
                                    placeholder="DD"
                                    className="centerPlaceHolder"
                                    value={this.state.renewalLeaseTermDD}
                                  />

                                </div>
                              </div>
                              <ErrorMessage
                                name="leaseRenewalTerm"
                                component="div"
                                className="text-red"
                              />
                            </div>
                          </div>

                          <div className="newGridSectionInner">
                            <label>From</label>
                            <div className="position-relative">
                              <Field type="date" name="from" />
                              <ErrorMessage name="from" component="div" className="text-red" />
                            </div>
                          </div>

                          <div className="newGridSectionInner">
                            <label>To</label>
                            <div className="position-relative">
                              <Field type="date" name="to" />
                              <ErrorMessage name="to" component="div" className="text-red" />
                            </div>
                          </div>

                          <div className="newGridSectionInner">
                            <label>
                              Clause Name <span className="astrik">*</span>
                            </label>
                            <div className="position-relative">
                              <Field
                                as="select"
                                name="otherDetails.clauseName"
                                onChange={(e) => {
                                  handleChange(e);
                                }}
                              >
                                <option value="" label="Select" defaultValue />
                                {this.state.otherClauses.map((obj) => (
                                  <option key={obj.id} value={obj.clause_name}>
                                    {obj.clause_name}
                                  </option>
                                ))}
                              </Field>
                              {this.validator.message(
                                "Clause Name",
                                values.otherDetails.clauseName,
                                "required",
                                { className: "text-danger" }
                              )}
                            </div>
                          </div>

                          <div className="newGridSectionInner">
                            <label>
                              Details <span className="astrik">*</span>
                            </label>
                            <div className="position-relative">
                              <Field
                                as="textarea"
                                className="details"
                                name="otherDetails.details"
                              />
                              {this.validator.message(
                                "Details",
                                values.otherDetails.details,
                                "required",
                                { className: "text-danger" }
                              )}
                            </div>
                          </div>

                          <div className="newGridSectionInner">
                            <label>
                              Document List <span className="astrik">*</span>
                            </label>
                            <div className="position-relative">
                              <Field
                                as="select"
                                name="otherDetails.document"
                                onChange={(e) => {
                                  handleChange(e);
                                }}
                              >
                                <option value="" label="Select" defaultValue />
                                {this.state.uploadedDocuments.map((obj) => (
                                  <option key={obj.leaseDocumentType} value={obj.leaseDocumentUrl}>
                                    {obj.leaseDocumentType} ({this.formatDate(obj.leaseUploadDocumentDate)})
                                  </option>
                                ))}
                              </Field>
                              {this.validator.message(
                                "Document List",
                                values.otherDetails.document,
                                "required",
                                { className: "text-danger" }
                              )}
                            </div>
                          </div>

                          <div className="newGridSectionInner">
                            <label>
                              Page No. <span className="astrik">*</span>
                            </label>
                            <div className="position-relative">
                              <Field
                                type="text"
                                name="otherDetails.pageNo"
                                onChange={(e) => {
                                  this.state.pageNo = e.target.value;
                                  handleChange(e);
                                }}
                              />
                              {this.validator.message(
                                "Page No",
                                values.otherDetails.pageNo,
                                "required",
                                { className: "text-danger" }
                              )}
                            </div>
                          </div>

                          <div className="gridColOneByThree">
                            <span className="remarks">Notes/Remarks</span>
                            <Field as="textarea" className="notes mb-3" name="notes_15" />
                          </div>

                        </div>
                        <div className="button_group mt-3 d-flex align-items-center gap-2 justify-content-end">
                          <button
                            className="add_button"
                            type="button"
                            onClick={(e) => {
                              if (this.addOtherDetails(values)) {
                                resetForm();
                                this.validator.hideMessages();
                              }
                            }}
                          >
                            Add
                          </button>
                          <button
                            className="reset_button"
                            type="reset"
                            disabled={isSubmitting}
                          >
                            Reset
                          </button>
                        </div>
                        {this.mainFormValidator.message(
                          "Other Clauses",
                          this.countError,
                          "required",
                          { className: "text-danger" }
                        )}
                        <div className="tableContainer p-0">
                          <table className="table tableSimple">
                            <thead>
                              <tr>
                                <th scope="col">#</th>
                                <th scope="col">Clause Name</th>
                                <th scope="col">Document Name</th>
                                <th scope="col">Document Date</th>
                                <th scope="col">Document Page Number</th>
                                <th scope="col">Information</th>
                                <th scope="col" colSpan="">
                                  Action
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              {this.state.otherClausesDetails.map(function (
                                name,
                                index
                              ) {
                                return (
                                  <tr key={"docTable" + index}>
                                    <td>{index + 1}</td>
                                    <td>
                                      <a
                                        // href=""
                                        className="clauseNameLink"
                                        onClick={(e) => {
                                          e.preventDefault();
                                          this.state.pageNo = name.pageNo;
                                          let obj =
                                            this.state.uploadedDocuments.find(
                                              (o) =>
                                              o.leaseDocumentType ===
                                              name.document && o.leaseDocumentUrl === name.documentUrl
                                            );
                                          this.state.currentDocument = obj.url;
                                          this.state.popupContentType = obj.uploadDocType;
                                          this.state.popupContentTypeDescription = name.details;
                                          this.openModal();
                                        }}
                                      >
                                        {name.clauseName}
                                      </a>
                                    </td>
                                    <td>{name.document}</td>
                                    <td>
                                      {this.showDocumentDate(name.documentUrl)}
                                    </td>
                                    <td>{name.pageNo}</td>
                                    <td>{name.pageNo}</td>
                                    <td>
                                      <button
                                        type="button"
                                        className="actionDelete rentalDeleteButton"
                                        onClick={(e) => {
                                          var _docs =
                                            this.state.otherClausesDetails;
                                          _docs.splice(index, 1);
                                          console.log(_docs, "new array");
                                          this.setState({
                                            otherClausesDetails: _docs,
                                          });
                                        }}
                                      >
                                        <FontAwesomeIcon icon={faTimes} />
                                      </button>
                                    </td>
                                  </tr>
                                );
                              },
                                this)}
                            </tbody>
                          </table>
                          <div className="button_group mt-5 d-flex align-items-center gap-2 justify-content-end">
                            <button type="submit" className="add_button">
                              Save Draft
                            </button>
                            <button type="reset" className="reset_button">
                              <Link to="/createlease">
                                Cancel
                              </Link>
                            </button>
                          </div>
                        </div>
                        <div className="row m-0">
                          <div className="col-lg-12">
                            <Modal
                              show={this.state.isOpen}
                              onHide={this.closeModal}
                              size="lg"
                            >
                              <Modal.Header closeButton>
                                <Modal.Title>
                                  <div className="container modalBreadCrumbs">
                                    <div className="row m-0">
                                      <div className="col-lg-12">
                                        <ul>
                                          <li>Document</li>
                                        </ul>
                                      </div>
                                    </div>
                                  </div>
                                </Modal.Title>
                              </Modal.Header>
                              <Modal.Body>
                                <div className="container">
                                  <div className="row m-0">
                                    {this.state.popupContentType == 'pdf' ? (
                                      <PdfReader
                                        url={this.state.currentDocument}
                                        pageNumber={this.state.pageNo}
                                      />
                                    ) : (
                                      <div>
                                        {this.state.popupContentTypeDescription}
                                      </div>
                                    )
                                    }
                                  </div>
                                </div>
                              </Modal.Body>
                            </Modal>
                          </div>
                        </div>
                      </div>
                    </Form>
                  </div>

                
                </>
              )}
            </Formik>
          </div>
        </div>
        <PopupMessage
          open={this.state.messsagePopup}
          content={this.state.popupContent}
          redirectAfterSave={this.redirectAfterSave}
        />
      </div>
    );
  }
}

export default withRouter(OtherClauses);
